import React, { useState, useEffect } from "react";
import "./ItineraryDetails.css";

function Summarydetails(props) {
//console.log(props);
  const [summaryTabData, seSummaryTabData] = useState(props.summaryTabData);


  return (
    <div className="summaryWrapper">
      <div className="summaryContainer">
        <div className="summaryDetailsWrapper">
          {/* <div className="flexContainer paddingLeft18">
            <div className="flexContainer appendTop5">
              <span className="circle appendTop15"></span>
              <span className="dashedLine"></span>
            </div>
            <div className="flexContainer appendLeft10 appendTop15">
              <img
                src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-flight@3x.png"
                width="16"
                height="17"
                alt="flightIcon"
              />
              <span className="transferText appendLeft7 font12">
                Arrival in Goa - Dabolim Airport by{" "}
                <b>
                  IndiGo Flight 6E-6603
                  <b>
                    {" "}
                    | Departing on 18 Apr, 07:25 PM | Arriving on 18 Apr, 09:55
                    PM | Includes Check In Baggage
                  </b>
                </b>
              </span>
            </div>
          </div> */}
          {/* <div className="flexContainer paddingLeft18">
            <div className="flexContainer appendTop5">
              <span className="circle appendTop15"></span>
              <span className="dashedLine"></span>
            </div>
            <div className="flexContainer appendLeft10 appendTop15">
              <img
                src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-cab@3x.png"
                width="16"
                height="17"
                alt="carIcon"
              />
              <span className="transferText appendLeft7 font12">
                Airport to hotel in Goa
              </span>
            </div>
          </div> */}
          <div className="summaryCardWrapper">
            <div className="summaryHeadingWrapper">
              <div className="font18 latoBlack">
                Summary<span className="latoRegular"> Details</span>
              </div>
            </div>
              {summaryTabData.length >0 && summaryTabData.map((tab, index) => (


            <div className="bodyWrapper">
            <div className="dayWrapper">
              <div className="font14 latoBlack darkText">Day {index+1}</div>
              <div className="font11">{tab?.label}</div>
            </div>

            <div>
            {tab?.content}
            </div>
              
          </div>
             ))}
            {/* <div className="bodyWrapper">
              <div className="dayWrapper">
                <div className="font14 latoBlack darkText">Day 2</div>
                <div className="font11">Apr 19, Fri</div>
              </div>
              <div className="dayRowContainer">
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-activity@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      North Goa Sightseeing (Private Transfers)
                    </span>
                  </div>
                  <span className="verticalBar downBar"></span>
                </div>
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-activity@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">Dolphin Trip</span>
                  </div>
                </div>
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-meal-copy@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Day Meals: <b>Breakfast : </b>Included at Hotel Regent
                      Laguna , Goa
                    </span>
                  </div>
                  <span className="verticalBar "></span>
                </div>
                <div className="summaryDetailWrapper"></div>
              </div>
            </div>
            <div className="bodyWrapper">
              <div className="dayWrapper">
                <div className="font14 latoBlack darkText">Day 3</div>
                <div className="font11">Apr 20, Sat</div>
              </div>
              <div className="dayRowContainer">
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-activity@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Discover Sailing Goa One Boat Experience{" "}
                    </span>
                  </div>
                  <span className="verticalBar downBar"></span>
                </div>
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-meal-copy@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Day Meals: <b>Breakfast : </b>Included at Hotel Regent
                      Laguna , Goa
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bodyWrapper">
              <div className="dayWrapper">
                <div className="font14 latoBlack darkText">Day 4</div>
                <div className="font11">Apr 21, Sun</div>
              </div>
              <div className="dayRowContainer">
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-activity@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      South Goa Sightseeing (Private Transfers)
                    </span>
                  </div>
                  <span className="verticalBar downBar"></span>
                </div>
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-meal-copy@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Day Meals: <b>Breakfast : </b>Included at Hotel Regent
                      Laguna , Goa
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bodyWrapper">
              <div className="dayWrapper">
                <div className="font14 latoBlack darkText">Day 5</div>
                <div className="font11">Apr 22, Mon</div>
              </div>
              <div className="dayRowContainer">
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-meal-copy@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Day Meals: <b>Breakfast : </b>Included at Hotel Regent
                      Laguna , Goa
                    </span>
                  </div>
                  <span className="verticalBar "></span>
                </div>
                <div className="summaryDetailWrapper">
                  <div className="summaryDetailContainer">
                    <img
                      src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-hotel@3x.png"
                      width="20"
                      height="20"
                      alt="lob icon"
                      className="appendRight5"
                    />
                    <span className="font12">
                      Checkout from <b>Hotel in Goa</b>
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="flexContainer paddingLeft18">
            <div className="flexContainer appendTop5">
              <span className="circle appendTop15"></span>
              <span className="dashedLine"></span>
            </div>
            <div className="flexContainer appendLeft10 appendTop15">
              <img
                src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-cab@3x.png"
                width="16"
                height="17"
                alt="carIcon"
              />
              <span className="transferText appendLeft7 font12">
                Hotel in Goa to Airport
              </span>
            </div>
          </div> */}
          {/* <div className="flexContainer paddingLeft18">
            <div className="flexContainer appendTop5">
              <span className="circle appendTop15"></span>
              <span className="dashedLine"></span>
            </div>
            <div className="flexContainer appendLeft10 appendTop15">
              <img
                src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/icon-16-flight@3x.png"
                width="16"
                height="17"
                alt="flightIcon"
              />
              <span className="transferText appendLeft7 font12">
                Departure from Goa (North) by{" "}
                <b>
                  SpiceJet Flight SG-8172
                  <b>
                    {" "}
                    | Departing on 22 Apr, 07:30 PM | Arriving on 22 Apr, 10:10
                    PM | Includes Check In Baggage
                  </b>
                </b>
              </span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Summarydetails;
